import { Badge, Icon, Tooltip } from "@chakra-ui/react";
import { Mail } from "lucide-react";
import { addHours } from "date-fns";
import { formatSp, parseAsUtc } from "../../../../lib/datetime";

const REMINDER_INTERVAL_HOURS = 6;

interface ReminderBadgeProps {
  count: number;
  lastSent: string | null;
}

export const ReminderBadge = ({ count, lastSent }: ReminderBadgeProps) => {
  const badgeLabel =
    count === 0 ? "Nenhum lembrete enviado"
    : count === 1 ? "1 lembrete enviado"
    : `${count} lembretes enviados`;

  const tooltipLabel = lastSent
    ? (() => {
        const fmt = "dd/MM/yyyy 'às' HH:mm";
        const nextInstant = addHours(parseAsUtc(lastSent), REMINDER_INTERVAL_HOURS);
        return `Último envio: ${formatSp(lastSent, fmt)}\nPróximo envio: ${formatSp(nextInstant.toISOString(), fmt)}`;
      })()
    : count === 0
      ? "Nenhum lembrete enviado até agora"
      : "Histórico de envios indisponível";

  return (
    <Tooltip
      label={tooltipLabel}
      hasArrow
      placement="top"
      whiteSpace="pre-line"
      bg="gray.800"
      color="white"
      fontSize="sm"
      fontWeight="medium"
      px={4}
      py={3}
      borderRadius="md"
      boxShadow="lg"
      gutter={12}
    >
      <Badge
        display="inline-flex" alignItems="center" gap={1.5}
        colorScheme={count > 0 ? "blue" : "gray"}
        variant="subtle" borderRadius="full" px={3} py={1}
        textTransform="none" fontWeight="semibold" fontSize="xs"
        cursor="help"
      >
        <Icon as={Mail} boxSize={3.5} />
        {badgeLabel}
      </Badge>
    </Tooltip>
  );
};
